import styles from "./styles.module.scss";

export function NotificationContent({
  message,
  time,
  isRead = true,
  compact = false,
}) {
  const timeClassName = [
    compact ? styles.timeCompact : styles.time,
    !isRead ? styles.timeUnread : "",
  ]
    .filter(Boolean)
    .join(" ");

  if (compact) {
    return (
      <div className={styles.contentCompact}>
        <p className={styles.messageCompact}>{message}</p>
        <span className={timeClassName}>{time}</span>
      </div>
    );
  }

  return (
    <div className={styles.content}>
      <div className={styles.contentRow}>
        <p className={styles.message}>{message}</p>
        <span className={timeClassName}>{time}</span>
      </div>
    </div>
  );
}
